import React from "react";
import VerificaEmpresa from "./pages/verificaempresa";
import Login from "./pages/login";
import './style/global.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Principal from './pages/principal';
import { AppProvider } from './context/AppContext.js';
import Humor from './pages/humor';
import Mochila from './pages/mochila';
import Lojinha from './pages/lojinha';


function App() {
  return (
    <AppProvider>
      <Router>
        <div>
          <Routes>
            <Route path="/" element={<VerificaEmpresa />} />
            <Route path="/login" element={<Login />} />
            <Route path="/principal" element={<Principal />} />
            <Route path="/humor" element={<Humor />} />
            <Route path="/mochila" element={<Mochila />} />
            <Route path="/lojinha" element={<Lojinha />} />
          </Routes>          
        </div>
      </Router>
    </AppProvider>
  );
}

export default App;
